module.exports = __webpack_public_path__ + "static/media/f4.5dd23ced.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/features/Hotel/components/Documentation/images/f4.jpg
// module id = 397
// module chunks = 0